import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SelectCountPipe } from './selectCount.pipe';

@NgModule({
    imports: [CommonModule],
    declarations: [SelectCountPipe],
    providers: [SelectCountPipe],
    exports: [SelectCountPipe],
})
export class SelectCountPipeModule {}
